"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SET_WEB3_INSTANCE = exports.SET_WALLET = exports.SET_TX_SUCCESS = exports.SET_TX_LOADING = exports.SET_TX_ERROR = exports.SET_NETWORK_ID = exports.SET_LOGIN_STATUS = exports.SET_INITIALIZED = exports.SET_CURRENT_ACCOUNT = exports.ADD_CONTRACT = void 0;
// WEB3 REDUCER
var SET_WEB3_INSTANCE = 'SET_WEB3_INSTANCE';
exports.SET_WEB3_INSTANCE = SET_WEB3_INSTANCE;
var ADD_CONTRACT = 'ADD_CONTRACT';
exports.ADD_CONTRACT = ADD_CONTRACT;
var SET_INITIALIZED = 'SET_INITIALIZED'; // TX HANDLER

exports.SET_INITIALIZED = SET_INITIALIZED;
var SET_TX_LOADING = 'SET_TX_LOADING';
exports.SET_TX_LOADING = SET_TX_LOADING;
var SET_TX_SUCCESS = 'SET_TX_SUCCESS';
exports.SET_TX_SUCCESS = SET_TX_SUCCESS;
var SET_TX_ERROR = 'SET_TX_ERROR'; //WALLET REDUCER

exports.SET_TX_ERROR = SET_TX_ERROR;
var SET_WALLET = 'SET_WALLET';
exports.SET_WALLET = SET_WALLET;
var SET_NETWORK_ID = 'SET_NETWORK_ID';
exports.SET_NETWORK_ID = SET_NETWORK_ID;
var SET_CURRENT_ACCOUNT = 'SET_CURRENT_ACCOUNT';
exports.SET_CURRENT_ACCOUNT = SET_CURRENT_ACCOUNT;
var SET_LOGIN_STATUS = 'SET_LOGIN_STATUS';
exports.SET_LOGIN_STATUS = SET_LOGIN_STATUS;